import React from 'react'
import Divider from '@components/Divider'
import {
    DIVIDER_SIZE,
} from '@helpers/constants'
import ExerciseBlock from '@components/ExerciseBlock'
import ExerciseHeader from '@components/ExerciseHeader'
import BlockRenderer from '@views/BlockRenderer'

const InstructionExercise = (props) => {
    const { content, name, image, preamble, showPanel, onShowPanel, onClosePanel } = props

    return (
        <>
            <ExerciseBlock
                name={name}
                onShowPanel={() => {
                    onShowPanel()
                }}
                preamble={preamble}
                image={image}
            >
                Starta övning
            </ExerciseBlock>
            <ExerciseHeader
                exerciseName={name}
                closePanel={() => onClosePanel(false)}
                openPanel={showPanel}
            >
                <Divider size={DIVIDER_SIZE.SMALL}/>
                <BlockRenderer
                    content={content}
                />
            </ExerciseHeader>
        </>
    )
}

export default InstructionExercise
